import { linkCallToCustomerAndLocation } from '@api/mutations/linkCallToCustomerAndLocation';
import { getActiveCallSid } from './getActiveCallSid';

export const linkCustomerToCall = async ({
  tenantId,
  customerId,
  locationId,
}: {
  tenantId: string;
  customerId: string;
  locationId: string | undefined;
}) => {
  const sid = getActiveCallSid();
  if (!sid) {
    return;
  }
  try {
    if (!locationId) {
      throw new Error(`Missing params location ID ${locationId}`);
    }
    await linkCallToCustomerAndLocation({
      tenantId,
      customerId,
      locationId,
      channelId: sid,
    });
  } catch (error) {
    // Do not show any error toasts here
    console.error('Error linking call to customer and location:', error);
  }
};
